import React from 'react';

import SignupFormContainer from '@alphapoint/apex-web/lib/components/Signup/SignupFormContainer';
import redirectIfAuthorized from '@alphapoint/apex-web/lib/hocs/redirectIfAuthorized';
import StandAloneLayout from '../layouts/StandAloneLayout/StandAloneLayout';

import '../styles/components/common/StandaloneForm.css';
import './SignupPage.css';

export const SignupFormComponent = () => {
  return (
    <StandAloneLayout>
      <SignupFormContainer />
    </StandAloneLayout>
  );
};

export default redirectIfAuthorized(SignupFormComponent);
